<template>
  <v-footer color="secondary" padless :app="!mobile" inset class="mt-4">
    <v-row justify="space-around" no-gutters>
      <v-col cols="12" v-if="comunicados.length > 0">
        <NewsCard />
      </v-col>
      <v-btn
        color="white"
        text
        x-small
        :block="mobile"
        rounded
        class="my-1"
        @click="copiarTexto('soporte@maximiza.cl')"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              @mouseleave="copyText = 'Copiar'"
              :class="mobile ? 'texto-footer' : ''"
            >
              {{ links[0].name }}
            </span>
          </template>
          <span>{{ copyText }}</span>
        </v-tooltip>
      </v-btn>
      <v-btn
        color="white"
        text
        x-small
        :block="mobile"
        rounded
        class="my-1"
        :href="links[1].link"
        target="_blank"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              :class="mobile ? 'texto-footer' : ''"
            >
              {{ links[1].name }}
            </span>
          </template>
          <span>{{ "Ver en Google Maps" }}</span>
        </v-tooltip>
      </v-btn>
      <v-btn
        color="white"
        text
        x-small
        :block="mobile"
        rounded
        class="my-1"
        @click="copiarTexto('+56999231921')"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              :class="mobile ? 'texto-footer' : ''"
              @mouseleave="copyText = 'Copiar'"
            >
              {{ links[2].name }}
            </span>
          </template>
          <span>{{ copyText }}</span>
        </v-tooltip>
      </v-btn>
      <v-col
        class="complementary text-center white--text"
        cols="12"
        style="font-size: 14px"
      >
        ©
        <a
          class="white--text text-decoration-none font-weight-medium"
          href="https://maximiza.cl/"
          target="_blank"
        >
          Maximiza
        </a>
        {{ new Date().getFullYear() }}

        <v-tooltip
          v-if="prod"
          color="white"
          top
          content-class="version-tooltip"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="complementary"
              icon
              small
              absolute
              right
            >
              <v-icon small left> mdi-help-box </v-icon>
            </v-btn>
          </template>
          <span>{{ build }}</span>
        </v-tooltip>
        <div
          v-else
          style="position: absolute; right: 0px; bottom: 0px; margin-right: 4px"
        >
          <span> V. {{ build }} </span>
        </div>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import NewsCard from "./NewsCard.vue";

export default {
  components: {
    NewsCard,
  },
  data: () => ({
    copyText: "Copiar",
    build: process.env.VUE_APP_BUILD_DATE,
    prod: process.env.VUE_APP_MODE == "PROD",
    links: [
      {
        name: "soporte@maximiza.cl",
      },
      {
        name: "Casa Matriz: Cerro Colorado #5870 Oficina 110 Las Condes",
        link: "https://goo.gl/maps/TR4NT9UCAgqAXCAH9",
      },
      { name: "+56 9 9923 1921" },
    ],
  }),
  methods: {
    ...mapActions(["switchDrawer"]),
    copiarTexto(value) {
      navigator.clipboard.writeText(value);
      this.copyText = "Copiado !";
    },
  },
  computed: {
    ...mapState(["comunicados"]),
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        default:
          return false;
      }
    },
  },
  mounted() {
    if (this.mobile) {
      this.switchDrawer(false);
    }
  },
};
</script>
<style scoped lang="css">
.texto-footer {
  width: min-content;
  white-space: normal;
  flex: auto;
  text-align: center;
}
.version-tooltip {
  font-size: 10px !important;
  color: black;
  padding: 0px 5px !important;
}
</style>
